import React, { useEffect, useState } from "react";
import { Progress } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Recorder from "../../components/video-recorder";
import { updateAnswer, notifyInterviewEnd } from "../../services/interviews";
import { uploadVideo } from "../../services/video";
import { useProcess } from "../../contexts/ProcessContext";
import "./styles.scss";

const Interview = () => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const {
    loading,
    processId,
    interviewId,
    candidateId,
    candidateMail,
    questions,
    currentQuestion,
    ready,
    updateState,
    interviewInfo,
  } = useProcess();

  const [videoLoading, setVideoLoading] = useState(false);

  useEffect(() => {
    // Verificar si el usuario tiene permiso para acceder a la entrevista
    if (!location.state?.allowed) {
      history.push(`/processes/${processId}/test`);
    }
  }, [location.state?.allowed, history, processId]);

  const handleVideoRecorded = async (videoId) => {
    setVideoLoading(true);

    try {
      const data = {
        video: { id: videoId },
        state: "COMPLETE",
      };

      await updateAnswer(data, questions[currentQuestion].answers[0]?.id);

      // Calcular nueva pregunta actual
      let newCurrentQuestion = 0;
      questions.forEach((question, i) => {
        if (
          currentQuestion >= i ||
          question.answers.some((a) => a.state === "COMPLETE")
        ) {
          newCurrentQuestion += 1;
        }
      });
      console.log("b. Nueva pregunta actual:", newCurrentQuestion);
      console.log("b. Total de preguntas:", questions);

      // Verificar finalización con el NUEVO valor calculado
      if (questions.length <= newCurrentQuestion) {
        try {
          await notifyInterviewEnd({
            interview_id: interviewId,
            personal_user_email: candidateMail,
          });
        } catch {
          console.log("Error en notificación");
        }
        history.push(`/processes/${processId}/finished`);
        return;
      }

      // Actualizar a la siguiente pregunta inmediatamente
      updateState({ currentQuestion: newCurrentQuestion, ready: true });
    } catch (err) {
      console.error("Ocurrió un error", err);
    } finally {
      setVideoLoading(false);
    }
  };

  const handleUploadVideo = async (data) => {
    return await uploadVideo(data);
  };

  const isLoading = loading || videoLoading;

  useEffect(() => {
    if (questions[currentQuestion]) {
      updateAnswer(
        { state: "STARTED" },
        questions[currentQuestion].answers[0]?.id,
      ).catch((err) => {
        console.error("Error updating answer to IN_PROGRESS:", err);
      });
    }
  }, [currentQuestion, questions]);

  return (
    <div className="pd">
      {isLoading ? (
        <Progress percent={100} status="active" showInfo={false} />
      ) : null}
      {!isLoading && questions.length > currentQuestion && ready ? (
        <div
          style={{
            padding: "3rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            boxShadow: "2px 2px 8px 0px #00000029",
            borderRadius: 8,
            background: "#FFFFFF",
            width: "min(90%, 600px)",
            position: "relative",
          }}
        >
          <span
            style={{ color: "#595959", fontSize: "1.5rem", fontWeight: 600 }}
          >
            {questions[currentQuestion]?.text || ""}
          </span>
          {questions[currentQuestion] &&
          questions[currentQuestion].time &&
          questions[currentQuestion].time < 301 ? (
            <Recorder
              className="video__wrapper"
              time={questions[currentQuestion].time || 10}
              handleVideoRecorded={handleVideoRecorded}
              uploadVideo={handleUploadVideo}
              questionId={questions[currentQuestion].id}
              questions={questions}
              candidateId={candidateId}
              interviewId={interviewId}
              trials={interviewInfo.questionMaxAttempts}
              flashInterview={interviewInfo.flashInterview}
              currentQuestion={questions[currentQuestion]}
              questionCount={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "8px 16px",
                    border: "1px solid #D9D9D9",
                    borderRadius: 8,
                    color: "#595959",
                  }}
                >
                  <QuestionCircleOutlined
                    style={{ fontSize: 16, color: "#2F54EB" }}
                  />
                  {t("frontvint__question_counter", {
                    current: currentQuestion + 1,
                    total: questions.length,
                  })}
                </div>
              }
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default Interview;
